import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomPasswordInput from "../../../common/CustomPasswordInput";
import { Images } from "../../../../config/images";
import { useTenantResetPassword } from "../../../../hooks/tenant/useTenantResetPassword";

const TeacherChangePassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const role = searchParams.get("role");
  const inputRef = useRef(null);
  const { loading, error, resetPassword } = useTenantResetPassword();
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters long")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      ),

    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const handleLogin = async (values, { resetForm }) => {
    const { password, confirmPassword } = values;
    await resetPassword(
      { token, password, role, confirmPassword, email },
      () => {
        resetForm();
        setSuccess(true);
        navigate("/login");
      }
    );
  };

  return (
    <>
      <section className="tenant-login-wrapper">
        <div className="tenant-login-card">
          {/* Logo */}
          <div className="tenant-login-logo">
            <img src={Images.Logo} alt="logo" onClick={() => navigate("/")} />
            <p className="tenant-login-title">Create a new password.</p>
          </div>

          {/* Form */}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form className="d-flex flex-column gap-3">
                <CustomPasswordInput
                  label="Password"
                  name="password"
                  type="password"
                  placeholder="Enter your password"
                  className="custom-primary-input"
                  layout="stacked"
                  ref={inputRef}
                />
                <CustomPasswordInput
                  label="Confirm Password"
                  name="confirmPassword"
                  type="password"
                  placeholder="Enter your password"
                  className="custom-primary-input"
                  layout="stacked"
                />

                <div>
                  {/* API Error */}
                  {error && (
                    <div className="custom-error text-center">{error}</div>
                  )}
                </div>
                {success && (
                  <div className="custom-success text-center">
                    Password reset successfully!
                  </div>
                )}

                {/* Submit Button */}
                <div>
                  <button
                    type="submit"
                    className="custom-primary-button"
                    disabled={loading || isSubmitting}
                  >
                    {loading ? "Resetting password..." : "Reset Password"}
                  </button>
                  <div className="go-back-container">
                    <div
                      className="go-back-btn"
                      onClick={() => navigate("/login")}
                    >
                      <i className="bi bi-arrow-left icon-shadow"></i>
                      <div className="pl-4"> Back to Login</div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </section>
    </>
  );
};

export default TeacherChangePassword;
